// src/pages/NotFound.js
import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "50px",
        height: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for doesn’t exist.</p>
      <Link to="/" style={{ color: "blue" }}>
        Go Back Home
      </Link>
    </div>
  );
};

export default PageNotFound;
